export type RouteContext =
  | 'breakdownLocation'
  | 'destination'

interface AdditionalInfoStructure {
  breakdownLocation?: string
  destination?: string
  general?: string
}

const trimWhitespace = (str: string): string => {
  return str.replace(/[\r\n\s]+$/, '')
}

export const parseAdditionalInfo = (additionalInfo: string | null | undefined): AdditionalInfoStructure => {
  if (!additionalInfo || additionalInfo.trim() === '') {
    return {}
  }

  try {
    const parsed = JSON.parse(additionalInfo)
    if (typeof parsed === 'object' && parsed !== null) {
      return parsed
    }
  } catch (e) {
    // Not valid JSON, try to parse the old formatted string
    const structure: AdditionalInfoStructure = {}
    
    // Extract general note (everything before first "Lisäselvitykset")
    const generalMatch = additionalInfo.match(/^([\s\S]*)(?=\nLisäselvitykset|$)/)
    if (generalMatch && generalMatch[1]) {
      structure.general = trimWhitespace(generalMatch[1])
    }
    
    // Extract breakdownLocation
    const breakdownNewMatch = additionalInfo.match(/Lisäselvitykset kohteessa:\s*([\s\S]*?)(?:\s*-*\s*<<|(?=\nLisäselvitykset)|$)/)
    if (breakdownNewMatch && breakdownNewMatch[1]) {
      structure.breakdownLocation = trimWhitespace(breakdownNewMatch[1])
    } 
    
    // Extract destination
    const destinationNewMatch = additionalInfo.match(/Lisäselvitykset määränpäässä:\s*([\s\S]*?)(?:\s*-*\s*<<|(?=\nLisäselvitykset)|$)/)
    if (destinationNewMatch && destinationNewMatch[1]) {
      structure.destination = trimWhitespace(destinationNewMatch[1])
    } 
    
    // If we extracted any sections, return the structure
    // Otherwise, treat the whole thing as general
    if (Object.keys(structure).length > 0) {
      return structure
    }
    
    return { general: trimWhitespace(additionalInfo) }
  }
  
  return { general: trimWhitespace(additionalInfo) }
}
